import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getMessageFromActions } from 'js/hooks/server';
import { LAYER, useSmartClosePopups } from 'js/components/common/PopupManager';
import { closePopupsAction } from 'js/components/common/PopupManager/store/actions';
import { useTwoFactorAuthenticationPopup } from 'js/components/popups/TwoFactorAuthenticationPopup';

import { VALIDATION_TYPE } from '../constants';
import { resendLogin2FAToken } from '../../../pas';

export const useValidate2FA = () => {
    const dispatch = useDispatch();
    const closePopups = useSmartClosePopups();
    const showTwoFactorAuthenticationPopup = useTwoFactorAuthenticationPopup();

    return useCallback((pasLoginResponse) => new Promise((resolve, reject) => {
        const { sessionValidationData = {} } = pasLoginResponse?.data || {};

        if (!sessionValidationData.SessionValidationBy2FAData) {
            resolve();

            return;
        }

        let isValid = false;

        showTwoFactorAuthenticationPopup({
            initiator: 'login',
            id: VALIDATION_TYPE.TWO_FACTOR_AUTHENTICATION,
            title: getMessageFromActions(pasLoginResponse),
            onSuccess: () => {
                isValid = true;
                dispatch(closePopupsAction({ popups: [VALIDATION_TYPE.TWO_FACTOR_AUTHENTICATION] }));
                resolve();
            },
            onClose: () => {
                if (!isValid) {
                    closePopups({ excludeLayers: [LAYER.LOGIN] });
                    reject(pasLoginResponse);
                }
            },
            resendHandler: resendLogin2FAToken,
            showTrustDeviceOption: sessionValidationData.SessionValidationBy2FAData[0]?.showTrustDeviceOption
        });
    }), [
        showTwoFactorAuthenticationPopup, closePopups, dispatch
    ]);
};
